import { useQuery } from '@tanstack/react-query';

import { Account, GUID } from '@ndvr/portfolio-api';

import { Configuration, FilterType, PortfolioApi } from '@/cip/_openapi/portfolio-optimizer';
import { defaultApiConfig } from '@/cip/api/defaultApiConfig';

const portfolioApi = new PortfolioApi(new Configuration(defaultApiConfig));

export const useAccountPortfolio = (accountGUID?: GUID<Account>) =>
    useQuery({
        queryKey: ['portfolio', 'account', accountGUID],
        queryFn: async () => {
            const page = await portfolioApi.getReportPortfolio({
                pageIndex: 0,
                pageSize: 1,
                filter: [
                    {
                        type: FilterType.STRING,
                        field: 'portfolio_guid',
                        value: accountGUID,
                    },
                ],
            });
            return page.portfolios?.length > 0 ? page.portfolios[0] : null;
        },
        enabled: !!accountGUID,
    });
